/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { Registration } from './components/Registration';
import { ForgotPassword } from './components/ForgotPassword';
import { Login } from './components/Login';
import { toAbsoluteUrl } from '../../../_vtsl/helpers';
import { ResellerLogin } from './components/ResellerLogin';
import { ForgotPasswordReseller } from './components/ForgotPasswordReseller';
const AuthLayout = () => {
    useEffect(() => {
        document.body.style.backgroundImage = 'none';
        return () => { };
    }, []);
    return (<div className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'>
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Logo */}
        <a href='https://www.vtsl.net/' target='_blank' rel="noopener noreferrer" className='mb-12' >
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/vtsl-logo.png')} className='theme-dark-show h-45px'/>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/vtsl_logo_black.png')} className='theme-light-show h-75px'></img>
        </a>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className='w-full w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 md:mx-auto'>
          <Outlet />
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className='d-flex flex-center flex-column-auto p-10'>
        <div className='d-flex align-items-center fw-semibold fs-6'>
          <a href='https://www.vtsl.net/about/' target='_blank' rel="noopener noreferrer" className='text-muted text-hover-primary px-2'>
            About
          </a>

          <a href='https://www.vtsl.net/about/contact-us/' target='_blank' rel="noopener noreferrer" className='text-muted text-hover-primary px-2'>
            Contact
          </a>

          <a href='https://www.vtsl.net/privacy-notice' target='_blank' rel="noopener noreferrer" className='text-muted text-hover-primary px-2'>
            Data Protection & Privacy Policy
          </a>
        </div>
      </div>
      {/* end::Footer */}
    </div>);
};
const AuthPage = () => (<Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />}/>
      <Route path='resellerLogin' element={<ResellerLogin />}/>
      <Route path='registration' element={<Registration />}/>
      <Route path='forgot-password' element={<ForgotPassword />}/>
      <Route path='forgot-password-reseller' element={<ForgotPasswordReseller />}/>

      <Route index element={<Login />}/>
    </Route>
  </Routes>);
export { AuthPage };
